import type { IncidentFieldRule } from './types';

export const customerSatisfactionFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What kind of customer satisfaction issue is this?',
        description: 'Select the type of customer satisfaction issue.',
        order: 90,
    },
    {
        key: 'affectedCustomer',
        label: 'Which customer is affected?',
        description: 'Enter the name of the affected customer.',
        order: 100,
    },
    {
        key: 'impactSLAsOrOperationalDelivery',
        label: 'Did this impact SLAs or operational delivery?',
        description: 'Select Yes if service levels or delivery commitments were affected.',
        order: 110,
    },
    {
        key: 'relevantServiceDeliveryManagerNotified',
        label: 'Has the service delivery manager been notified?',
        description: 'Select Yes if the responsible service delivery manager has been informed.',
        order: 120,
    },
    {
        key: 'customerCommunicationFollowUpRequired',
        label: 'Is customer follow-up required?',
        description: 'Select Yes if the customer needs to be contacted about this incident.',
        order: 130,
    },
];
